<template>
  <m-input-autocomplete
    :label="this.$t('games.add')"
    :data="addableGamesMeta.loading ? [] : addableGames"
    field="name"
    :value="filter"
    :placeholder="this.$t('common.game')"
    @typing="inputHandler"
    @input="handleSelect"
  >
    <template v-slot:default="{option: game}">
      <div class="game-row">
        <div class="game-name">
          {{ game.name }}
        </div>
        <div>{{ game.version }}</div>
      </div>
    </template>
  </m-input-autocomplete>
</template>

<script>
  import { useAddableGames } from '../views/integrations/integrationHooks'
  import { MInputAutocomplete } from 'codefabrik-gui-vue'
  import { debounce } from 'debounce'

  export default {
    name: 'GamesVersionSelect',
    components: { MInputAutocomplete },
    props: {
      integrationId: {
        type: String,
        default: ''
      },
    },
    data () {
      return {
        filter: '',
      }
    },
    mixins: [
      useAddableGames('addableGames')
    ],
    methods: {
      _handleInput (input) {
        this.filter = input
      },
      handleSelect (game) {
        if (game == null) return
        this.$emit('gameAdd', { integrationId: this.integrationId, gameVersionId: game.versionId })
      }
    },
    computed: {
      inputHandler () {
        return debounce((input) => this._handleInput(input), 500)
      }
    },
  }
</script>

<style
  lang='scss'
  scoped
>
  .game-row {
    display: grid;
    grid-template-columns: 2fr 3fr;
    grid-column-gap: 5px;
    white-space: initial;
  }

  .game-name {
    font-weight: bold;
  }
</style>
